import { useCallback, useEffect, useState } from "react";

/**
 * useChatWidgetsHidden — Iter v27 #1.
 * Shared per-browser persistence for the chat-popout visibility toggle so users can
 * hide both the floating CS chat and Agent chat bubbles while viewing data tables.
 * Re-enabled from the Layout user dropdown.
 */
const STORAGE_KEY = "rbb_chat_widgets_hidden";
const EVENT = "rbb-chat-widgets-toggle";

function readHidden() {
  try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
}

export function useChatWidgetsHidden() {
  const [hidden, setHiddenState] = useState(readHidden);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === STORAGE_KEY) setHiddenState(readHidden()); };
    const onCustom = () => setHiddenState(readHidden());
    window.addEventListener("storage", onStorage);
    window.addEventListener(EVENT, onCustom);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener(EVENT, onCustom);
    };
  }, []);

  const setHidden = useCallback((v) => {
    try {
      if (v) localStorage.setItem(STORAGE_KEY, "1"); else localStorage.removeItem(STORAGE_KEY);
    } catch { /* ignore */ }
    setHiddenState(!!v);
    window.dispatchEvent(new Event(EVENT));
  }, []);

  const toggle = useCallback(() => setHidden(!readHidden()), [setHidden]);

  return { hidden, setHidden, toggle };
}
